import * as React from "react";

const ElectrifiedIcon: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M16.5 2.696l-3 2.976-1.71-1.711-1.08 1.079.563.563-3.844 3.843a2.344 2.344 0 000 3.305l1.383 1.383-5.602 5.578 1.08 1.078 5.578-5.602 1.382 1.382a2.344 2.344 0 003.305 0l3.843-3.843.563.562 1.078-1.078-1.711-1.711 2.977-3-1.055-1.054-3 2.976-2.672-2.672 2.977-3L16.5 2.696zm-4.172 3.96l5.016 5.016-3.844 3.842c-.29.29-.905.29-1.195 0l-3.82-3.82c-.29-.29-.29-.905 0-1.195l3.843-3.843z"
                fill="#000"
            />
        </svg>
    )
};
export default React.memo(ElectrifiedIcon);
